import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWarningSign: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWarningSign"><Path fillRule="evenodd" clipRule="evenodd" d="M6.22096 3H17.7825L22.2144 20.7276L20.2741 21.2127L19.471 18H14.5325L13.7293 21.2127L11.7891 20.7276L12.471 18H4.53252L3.72935 21.2127L1.78906 20.7276L6.22096 3ZM17.0017 8.12311L15.0325 16H18.971L17.0017 8.12311Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWarningSign;
